<template>
  <div>
    <Breadcrumbs main="" title="firebase todo"/>
      <!-- Container-fluid starts-->
      <div class="container-fluid">
        <div class="row">

          <div class="col-xl-12">
            <div class="card">
              <div class="card-header firebase-header">
                <h5>Gift List (Firebase)</h5>
              </div>

              <div class="card-body custom-scrollbar">
                <div class="todo">
                  <div class="todo-list-wrapper">
                    <div class="todo-list-container">
                      <div class="table-responsive datatable-vue m-0 vue-smart">                                      
                        <v-table
                            :data="giftlist" class="table"
                            :currentPage.sync="basic.currentPage"
                            :pageSize="10"
                            @totalPagesChanged="basic.totalPages = $event"
                        >
                          <thead slot="head">
                            <th>Type</th>
                            <th>Market</th>
                            <th>Ver. Code</th>
                            <th>Item x Count</th>
                            <th>Given/Available</th>
                            <v-th sortKey="deadline">Deadline</v-th>
                            <th>Description</th>                            
                            <th>Status</th>
                            <th>Del</th>
                          </thead>
                          <tbody slot="body" slot-scope="{displayData}">
                            <tr v-for="(todo, index) in displayData" :key="index" class="task" :class="{'completed':todo.status == 'complete'}">
                              <td>
                                <b-badge v-if="todo.type=='ALL'" pill variant="success"><i class="icon-gift"></i> {{ todo.type }}</b-badge>
                                <b-badge v-else pill variant="secondary"><i class="icon-shop"></i> {{ todo.usage }}</b-badge>
                              </td>
                              <td>
                                <b-badge v-if="todo.market=='ALL'" pill variant="info">{{ todo.market }}</b-badge>
                                <b-badge v-else pill variant="success">{{ todo.market }}</b-badge>   
                              </td>                              
                              <td>{{ todo.versionCode }}</td>
                              <td>
                                <div v-for="(itemId, name) in itemlist" :key="name">
                                  <div v-if="itemId.itemId==todo.item.id">                                    
                                    <b-badge pill variant="success"> {{ itemId.name }}</b-badge> 
                                    <b-badge pill variant="info"><i class="icofont icofont-error"></i> {{ todo.item.count }}</b-badge>                                               
                                  </div>
                                </div>                                
                              </td>
                              <td><b-badge pill variant="success">{{ todo.giftGiven }}/{{ todo.giftAvailable }}</b-badge></td>
                              <td>{{ todo.deadline }}</td>
                              <td>
                                <p>
                                  <b-div v-if="todo.message.english!=''"><b-badge pill variant="success">English : {{ todo.message.english }}</b-badge><br></b-div>
                                  <b-div v-if="todo.message.korean!=''"><b-badge pill variant="info">Korean : {{ todo.message.korean }}</b-badge><br></b-div>
                                  <b-div v-if="todo.message.spanish!=''"><b-badge pill variant="info">Spanish : {{ todo.message.spanish }}</b-badge><br></b-div>
                                  <b-div v-if="todo.message.portuguese!=''"><b-badge pill variant="info">Portuguese : {{ todo.message.portuguese }}</b-badge><br></b-div>
                                  <b-div v-if="todo.message.french!=''"><b-badge pill variant="info">French : {{ todo.message.french }}</b-badge><br></b-div>
                                  <b-div v-if="todo.message.german!=''"><b-badge pill variant="info">German : {{ todo.message.german }}</b-badge><br></b-div>
                                  <b-div v-if="todo.message.russian!=''"><b-badge pill variant="info">Russian : {{ todo.message.russian }}</b-badge></b-div>
                                </p>
                              </td>
                              <td>
                                <span @click="taskActive(todo.id,todo.status)" class="action-box large complete-btn" title="Mark Complete">
                                  <b-badge v-if="todo.status=='INACTIVE'" pill variant="secondary"><i class="icon-check"></i>{{ todo.status }}</b-badge>
                                  <b-badge v-else pill variant="success"><i class="icon-check"></i>{{ todo.status }}</b-badge>
                                </span>  
                              </td>
                              <td>
                                <span class="task-action-btn">
                                  <span @click="tododelete(todo.id)" class="action-box large delete-btn" title="Delete Task"><i class="icon"><i class="icon-trash"></i></i></span>
                                </span>                            
                              </td>
                            </tr>
                          </tbody>
                        </v-table>      

                        <smart-pagination
                            :currentPage.sync="basic.currentPage"
                            :totalPages="basic.totalPages"
                        />
                      </div>
                    </div>
                  </div>
                  <div>
                    <notifications classes="task" group="giftlist" />
                  </div>
                </div>
              </div>
            </div>                
          </div>


        <div class="col-xl-12"> 
          <div class="default-according">
            <b-card no-body class="mb-1">
              <b-card-header header-tag="div" role="tab" class="bg-primary">
                <h5 class="mb-0">
                  <b-button v-b-toggle.sectionAddGift><i class="fa fa-pencil-square"></i> Add new gift <span class="digits"></span></b-button>
                </h5>
              </b-card-header>
              <b-collapse id="sectionAddGift" accordion="my-accordion" role="tabpanel">
                <b-card-body>

                <div class="row">
                  <div class="col-sm-3">
                    <h5 slot="header"> <i class="icon-settings"></i> Setting</h5>             
                    <div class="form-row">
                      <div class="col-md-12 mb-3">
                        <b-input-group prepend="Type" append="">                              
                          <b-form-select v-model="gift_type" :options="giftTypeOptions" id="gift_type" name="gift_type"></b-form-select>
                        </b-input-group> 
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="col-md-12 mb-3">
                        <b-input-group prepend="Market">
                          <b-form-select v-model="gift_market" :options="giftMarketOptions" id="gift_market" name="gift_market"></b-form-select>
                        </b-input-group>
                      </div>
                    </div>

                    <div class="form-row">  
                      <div class="col-md-12 mb-3">
                        <b-input-group prepend="Version Code">
                          <b-form-input v-model="gift_versionCode" type="number" placeholder="0" id="gift_versionCode" name="gift_versionCode"></b-form-input>
                        </b-input-group>
                      </div>                                          
                    </div>     

                    <div class="form-row">  
                      <div class="col-md-12 mb-3">                                          
                        <b-input-group prepend="Deadline">
                          <datepicker v-model="gift_deadline" input-class="datepicker-here form-control digits" :format="format" id="gift_deadline" name="gift_deadline"></datepicker>                              
                        </b-input-group>                                          
                      </div>  
                    </div>                        

                    <div class="form-row">
                      <div class="col-md-12 mb-3">
                        <b-input-group prepend="Gift Available">
                          <b-form-input v-model="gift_available" type="number" placeholder="0" id="gift_available" name="gift_available"></b-form-input>
                        </b-input-group>
                      </div>
                    </div>                        

                    <div class="form-row">
                      <div class="col-md-12 mb-3">
                        <b-input-group prepend="Item ID">
                          <b-form-select v-model="gift_itemId" id="gift_itemId" name="gift_itemId">
                            <option v-for="(todo, index) in itemlist" v-bind:key="index" :value="todo.itemId">{{todo.name}}</option>
                          </b-form-select>                                          
                        </b-input-group>                                                                      
                      </div>
                    </div>  
                    <div class="form-row">  
                      <div class="col-md-12 mb-3">
                        <b-input-group prepend="Item Count">
                          <b-form-input v-model="gift_itemCount" type="number" placeholder="0" id="gift_itemCount" name="gift_itemCount"></b-form-input>
                        </b-input-group>                                          
                      </div>
                    </div>                                                                                                                                                                    
                  </div>
                  
                  <!-- Message -->
                  <div class="col-sm-9">                      
                    <h5 slot="header"> <i class="icon-write"></i> Message</h5>
                    <div class="form-group mb-3">
                      <b-input-group prepend="English">
                        <b-input-group-prepend is-text><i class="flag-icon flag-icon-us" title="USA"></i>|<i class="flag-icon flag-icon-gb" title="United Kingdom"></i>|<i class="flag-icon flag-icon-au" title="Australia"></i></b-input-group-prepend>
                        <b-form-input v-model="gift_message_english" id="gift_message_english" name="gift_message_english" placeholder="Enter gift message here(Englis is default)..."></b-form-input>
                      </b-input-group>

                    </div>  
                    <div class="form-group mb-3">                            
                      <b-input-group prepend="Korean">
                        <b-input-group-prepend is-text><i class="flag-icon flag-icon-kr" title="Korea"></i></b-input-group-prepend>
                        <b-form-input v-model="gift_message_korean" id="gift_message_korean" name="gift_message_korean" placeholder=""></b-form-input>
                      </b-input-group>
                    </div>  
                    <div class="form-group mb-3">  
                      <b-input-group prepend="Spanish">
                        <b-input-group-prepend is-text><i class="flag-icon flag-icon-es" title="Spain"></i>|<i class="flag-icon flag-icon-mx" title="Mexico"></i></b-input-group-prepend>
                        <b-form-input v-model="gift_message_spanish" id="gift_message_spanish" name="gift_message_spanish" placeholder=""></b-form-input>
                      </b-input-group>
                    </div>  
                    <div class="form-group mb-3">  
                      <b-input-group prepend="Portuguese">
                        <b-input-group-prepend is-text><i class="flag-icon flag-icon-pt" title="Portugal"></i>|<i class="flag-icon flag-icon-br" title="Brazil"></i></b-input-group-prepend>
                        <b-form-input v-model="gift_message_portuguese" id="gift_message_portuguese" name="gift_message_portuguese" placeholder=""></b-form-input>
                      </b-input-group>
                    </div>  
                    <div class="form-group mb-3">  
                      <b-input-group prepend="French">
                        <b-input-group-prepend is-text><i class="flag-icon flag-icon-fr" title="France"></i>|<i class="flag-icon flag-icon-ca" title="Canada"></i></b-input-group-prepend>
                        <b-form-input v-model="gift_message_french" id="gift_message_french" name="gift_message_french" placeholder=""></b-form-input>
                      </b-input-group>
                    </div>  
                    <div class="form-group mb-3">  
                      <b-input-group prepend="German">
                        <b-input-group-prepend is-text><i class="flag-icon flag-icon-de" title="German"></i></b-input-group-prepend>
                        <b-form-input v-model="gift_message_german" id="gift_message_german" name="gift_message_german" placeholder=""></b-form-input>
                      </b-input-group>                                                                                    
                    </div>    
                    <div class="form-group mb-3">  
                      <b-input-group prepend="Russian">
                        <b-input-group-prepend is-text><i class="flag-icon flag-icon-ru" title="Russia"></i></b-input-group-prepend>
                        <b-form-input v-model="gift_message_russian" id="gift_message_russian" name="gift_message_russian" placeholder=""></b-form-input>
                      </b-input-group>                                                                                    
                    </div>                          
                  </div>    
                </div>
                <span @click="addnewtask()" class="btn btn-success ml-0 add-new-task-btn" id="add-task">Add Gift</span>

                </b-card-body>
              </b-collapse>
            </b-card>                                                                    
          </div>
        </div> 

        <div class="col-xl-12"> 
          <div class="default-according">
            <b-card no-body class="mb-1">
              <b-card-header header-tag="div" role="tab" class="bg-secondary">
                <h5 class="mb-0">
                  <b-button v-b-toggle.sectionHowto><i class="fa fa-question-circle"></i> Howto <span class="digits"></span></b-button>
                </h5>
              </b-card-header>
              <b-collapse id="sectionHowto" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  1. Gift는 불특정 다수의 사용자들에게 선착순으로 지정된 아이템을 지급해주는 서비스 입니다.<br>
                  2. 한번 등록한 Gift는 수정할수 없습니다. 삭제 후에 다시 등록해주시기 바랍니다.<br>
                  3. 한번에 너무 많은 아이템을 지급할 경우 콘텐츠 내의 경제가 붕괴됩니다. 주의해주시기 바랍니다.
                </b-card-body>
              </b-collapse>
            </b-card>                                                                    
          </div>
        </div>  

      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
  import { mapState } from "vuex";
  import items from '../../data/items';
  import Datepicker from 'vuejs-datepicker';
  import VueSlideBar from 'vue-slide-bar';

  export default{
    name:'todo',
    data(){
      return{
        format: "yyyy/MM/dd",
        gift_available:1000,
        gift_itemCount:1,

        items,

        basic:{
          currentPage: 1,
          totalPages: 0,
        },

        filter:{
          currentPage: 1,
          totalPages: 0,
        },

        idfilter:{
          currentPage: 1,
          totalPages: 0,
        },

        selectrow:{
          currentPage: 1,
          totalPages: 0,
        },

        filters: {
            usage: { value: '', keys: ['usage'] },
            type: { value: '', keys: ['type'] },
            versionCode: { value: '', keys: ['versionCode'] },
            item: { value: '', keys: ['item'] },
            giftAvailable: { value: '', keys: ['giftAvailable'] },
            giftGiven: { value: '', keys: ['giftGiven'] },
            deadline: { value: '', keys: ['deadline'] },
            message: { value: '', keys: ['message'] },
            created: { value: '', keys: ['created'] },
            status: { value: '', keys: ['status'] },
        },

        giftTypeOptions:[
            { value:'ALL', text: 'ALL(모두에게)', selected: true }
        ],

        giftMarketOptions:[
            { value:'ALL', text: 'All(모든 마켓)', selected: true },
            { value:'GOOGLE', text: 'Google Play'},
            { value:'ITUNES', text: 'iTunes'},
            { value:'ONESTORE', text: 'OneStore'},
            { value:'SAMSUNG', text: 'Samsung'},
            { value:'KDDI', text: 'KDDI'}
        ],

        giftItemOptions:[
            { value:['itemId'], text:['name']}
        ],

        gift_type : 'ALL',
        gift_market : 'ALL',
        gift_itemId : 1 // First option will be selected by default
      }
    },
    components: {
      Datepicker,
      VueSlideBar
    },
    computed: {
      ...mapState({
        itemlist: state => state.firebase_item.todo,
        giftlist: state => state.firebase_gift.todo,
      }),
      formatted(){
        return Vue.filter('date')(this.value)
      }      
    },
    created(){
      this.$store.dispatch('firebase_item/retrieveTodos')
      this.retrieveTodos();
    },

    methods:{

      retrieveTodos()
      {        
        this.$store.dispatch('firebase_gift/retrieveTodos')
      },

      taskActive(id, status)
      {
        this.$store.dispatch('firebase_gift/taskActive', id)
        this.retrieveTodos();

        if(status != "INACTIVE")
          this.$toasted.show("Gift marked as ACTIVE.", {theme: 'outline', type: 'success', duration: 2000});
        else
          this.$toasted.show("Gift marked as INACTIVE.", {theme: 'outline', type: 'error', duration: 2000});
      },

      tododelete(id)
      {
        this.$store.dispatch('firebase_gift/tododelete', id)
        this.retrieveTodos();
        this.$toasted.show("Task has been deleted.",{theme:'outline', type : 'success',duration:2000});
      },

      addnewtask()
      {
        if(this.gift_deadline == null)
        {
          this.$toasted.show("Must select deadline", {theme: 'outline', type: 'success', duration: 2000});
        }
        else if(this.gift_message_english == null)
        {
          this.$toasted.show("Must insert in english message", {theme: 'outline', type: 'success', duration: 2000});
        }
        else
        {
          this.$store.dispatch('firebase_gift/addtodo', this)

          this.gift_available = 1000
          this.gift_itemCount = 1

          this.gift_message_english = ""
          this.gift_message_korean = ""
          this.gift_message_spanish = ""
          this.gift_message_portuguese = ""
          this.gift_message_french = ""
          this.gift_message_german = ""
          this.gift_message_russian = ""
          /*
          var container = this.$el.querySelector(".todo-list-body");
          setTimeout(function () 
          {
            container.scrollBy({ top: 200, behavior: 'smooth' });
          }, 310)
          */

          this.$toasted.show("New gift has updated.",{theme:'outline', type : 'success',duration:2000});
          this.retrieveTodos();
        }
      }
    }
  }
</script>
